/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, FormattedDate, FormattedTime, injectIntl} from 'react-intl';

import {Table} from 'eui-components';

import styles from './ServerErrorView.css';

/**
 * Error view displayed when there's a server error.
 *
 * @param props error attributes. the attributes are provided by Spring Boot's BasicErrorController.
 * @returns {*}
 * @constructor
 */
const ServerError = (props) => {
  return (
    <div align="center" className={styles.container}>
      <div align='center'>
        <h3>
          <FormattedMessage id='ServerError.header'
            defaultMessage='We are unable to process your request at this moment.'/>
        </h3>
        <h4>
          <FormattedMessage id='ServerError.message'
            defaultMessage={`Try again, or contact OCLC support at {anchor}.`}
            values={{anchor: <a href="mailto:support@oclc.org">support@oclc.org</a>}}/>
        </h4>

        <Table bordered hover className={styles.errorDetail}>
          <tbody>
            <tr>
              <td><FormattedMessage id='ServerError.timestamp' defaultMessage={'Timestamp'}/></td>
              {props.error.timestamp
                ? <td><FormattedDate value={props.error.timestamp} /> <FormattedTime value={props.error.timestamp} /></td>
                : <td/>
              }
            </tr>
            <tr>
              <td><FormattedMessage id='ServerError.path' defaultMessage={'Request that failed'}/></td>
              <td>{props.error.path}</td>
            </tr>
            <tr>
              <td><FormattedMessage id='ServerError.status' defaultMessage={'Status code'}/></td>
              <td>{props.error.status}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

ServerError.propTypes = {
  error: PropTypes.shape({
    timestamp: PropTypes.number,
    path: PropTypes.string,
    status: PropTypes.number
  })
};

export default injectIntl(ServerError);



// WEBPACK FOOTER //
// ./src/ServerErrorView/ServerErrorView.js